export enum eTypeRelocatePosition {
  Origin = 1,
  Destiny = 2
}
